import { render, staticRenderFns } from "./DonationLists.vue?vue&type=template&id=424b98d8"
import script from "./DonationLists.vue?vue&type=script&lang=js"
export * from "./DonationLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports